import humanizeDuration, { Unit } from 'humanize-duration';
import { DateTime } from 'luxon';

const gridColsClass: Record<number, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
  5: 'grid-cols-5',
  6: 'grid-cols-6',
  7: 'grid-cols-7',
  8: 'grid-cols-8',
  9: 'grid-cols-9',
  10: 'grid-cols-10',
  11: 'grid-cols-11',
  12: 'grid-cols-12',
};

export function getGridColsClass(numberOfColumns: number): string {
  return gridColsClass[numberOfColumns] ?? 'grid-cols-1';
}

humanizeDuration.languages.shortEn = {
  y: () => 'y',
  mo: () => 'mo',
  w: () => 'w',
  d: () => 'd',
  h: () => 'h',
  m: () => 'm',
  s: () => 's',
  ms: () => 'ms',
};

export function humanizeDurationWithPrefix({
  dateTime,
  dateTimeToCompare,
  units = ['w', 'd', 'h', 'm', 's'],
  returnZero,
}: {
  dateTime: DateTime;
  dateTimeToCompare: DateTime;
  units?: Unit[];
  returnZero?: boolean;
}): string {
  const diff =
    dateTime?.diff(dateTimeToCompare, 'milliseconds').milliseconds ?? 0;
  const durationMs = Math.abs(diff);
  if (durationMs === 0 && !returnZero) {
    return '';
  }
  const humanized = humanizeDuration(durationMs, {
    round: true,
    language: 'shortEn',
    units: units,
    spacer: '',
  });
  const prefix = dateTime.equals(dateTimeToCompare)
    ? ''
    : dateTime > dateTimeToCompare
      ? '+'
      : '-';

  return `${prefix}${humanized}`;
}
